import type { VendorEventListItemDto } from '@lib/dto/vendor-event.dto'
import type { EventStatus } from '@lib/enums/event-lifecycle.enum'
import { VENDOR_SERVICE_LABELS, type VendorService } from '@lib/enums/vendor-service.enum'
import { vendorEventPath } from '@lib/helpers/vendor-event-path'

/** The word a vendor's list and its view of an event show, from what the API decided about it. */
export function vendorEventStatus(event: Pick<VendorEventListItemDto, 'lifecycle' | 'date' | 'hasFinished'>): EventStatus {
  // A vendor isn't on an inquiry, but one that was lost reads as called off.
  if (event.lifecycle === 'cancelled' || event.lifecycle === 'lost') return 'cancelled'
  if (event.lifecycle === 'enquiry' || event.date === null) return 'enquiry'
  if (event.hasFinished) return 'past'
  return 'booked'
}

/**
 * Why the company is on the event, in the venue team's words: "Planner",
 * "Floral", "Rentals". Both ways it can be there are named (decision 25).
 */
export function vendorEventReasons(services: readonly VendorService[], rents: boolean): string {
  const assigned = services.map((s) => (s === 'planning' ? 'Planner' : VENDOR_SERVICE_LABELS[s]))
  return [...assigned, ...(rents ? ['Rentals'] : [])].join(', ')
}

/**
 * Where the event's name leads, if anywhere. Planning opens the event itself;
 * any other way of being on it opens the vendor's read-only view. An event of a
 * locked organization is not opened: the couple is shown that the venue's
 * account is unavailable, and so is every vendor on it.
 */
export function vendorEventHref(event: Pick<VendorEventListItemDto, 'eventId' | 'services' | 'unavailable'>): string | null {
  if (event.unavailable) return null
  return vendorEventPath(event.eventId, event.services)
}
